module.exports = "../../fonts/vendor/@mdi/materialdesignicons-webfont.woff2?d5cba82059f88bfa469ecd8a0e313676";